import React from 'react';
import { Card, CardContent } from './ui/card';
import { industries } from '../data/mock';
import { Laptop, ShoppingCart, Coffee, Shirt, Heart, Briefcase, Tv, Factory } from 'lucide-react';

const iconMap = {
  Laptop,
  ShoppingCart,
  Coffee,
  Shirt,
  Heart,
  Briefcase,
  Tv,
  Factory
};

export const IndustriesSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">
            Industries We Serve
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We provide specialized trademark registration services across diverse industries, protecting brands of all sizes with tailored legal strategies.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {industries.map((industry, index) => {
            const Icon = iconMap[industry.icon];
            return (
              <Card
                key={index}
                className="border-2 border-emerald-200 hover:shadow-2xl transition-all duration-300 hover:border-amber-500 hover:-translate-y-2"
              >
                <CardContent className="p-8 text-center h-full flex flex-col">
                  <div className="bg-gradient-to-br from-emerald-100 to-amber-50 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-md">
                    <Icon className="h-10 w-10 text-emerald-700" />
                  </div>
                  <h3 className="text-xl font-bold text-emerald-900 mb-4">
                    {industry.name}
                  </h3>
                  <p className="text-gray-700 leading-relaxed text-sm flex-grow">
                    {industry.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-16 max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-emerald-50 to-amber-50 rounded-2xl p-8 md:p-12 text-center border-2 border-emerald-200">
            <h3 className="text-2xl md:text-3xl font-bold text-emerald-900 mb-4">
              Your Industry, Our Expertise
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              From startups to established enterprises, we've helped businesses across all industries secure their brand identity and protect their intellectual property through federal trademark registration. Our experienced team understands the unique challenges and trademark requirements specific to each sector, ensuring your application is strategically positioned for success. Whether you're launching a new brand or protecting an established one, we have the industry-specific knowledge to guide you through every step of the trademark registration process.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
